<template>
	<div class="viewAPI2">
		<common-head url="/newHome" :title="$t('tba.APIset')" :is-return="true"></common-head>
		
		<div class="bgWhite">
			<!-- <span class="help-btn" @click="getId()">帮助</span> -->
			<div class="body1Style">
				<p class="body1StylepFont">
					<span class="mainFontLightColor">{{ $t('tba.codeHasSend') }}</span>
					<strong class="mainFontColor" v-if="vcode_method == 'phone'">+86 {{ phone }}</strong>
					<span class="mainFontColor" v-if="vcode_method == 'email'">{{ email }}</span>
				</p>
				
				<div class="bodyStyleDivStyle">
					<p class="mainFontLightColor">{{ $t('tba.vcode') }}</p>
					<van-row>
						<van-col span="16"><input v-model="inputCode" maxLength="6" class="body1StyleInputStyle" type="text" ref="inputCode" style="font-weight: bold;" /></van-col>
						<van-col span="8" style="position: relative;">
							<button class="getCodeBtn" @click="onSendCode" :disabled="codeSending">
								<span v-if="codeSending">({{ theTime }})</span>
								<span v-else>{{ $t('sPhone.getCode') }}</span>
							</button>
						</van-col>
					</van-row>
				</div>

				<div class="bodyStyleDivStyle">
					<p class="mainFontLightColor">API KEY</p>
					<van-row>
						<van-col span="24"><input class="body1StyleInputStyle" v-model="apiUpdate.key" type="text" :placeholder="$t('tba.enterAPIKey')" /></van-col>
					</van-row>
				</div>

				<div class="bodyStyleDivStyle">
					<p class="mainFontLightColor">Secret KEY</p>
					<van-row>
						<van-col span="24"><input class="body1StyleInputStyle" v-model="apiUpdate.secret" type="text" :placeholder="$t('tba.enterSecretKey')" /></van-col>
					</van-row>
				</div>

				<div class="bodyStyleDivStyle divTopInChong" v-if="exchange_id == 3">
					<p class="mainFontLightColor">Passphrase</p>
					<van-row>
						<van-col span="24"><input class="body1StyleInputStyle" v-model="apiUpdate.passphrase" type="text" :placeholder="$t('tba.enterPassphrase')" /></van-col>
					</van-row>
				</div>
			</div>
			<div class="bottom2DivStyle">
				<p class="bottom2PStyle">1：{{ $t('tba.setWord1') }}{{ exchange_name }}{{ $t('tba.setWord1_2') }}</p>
				<p class="bottom2PStyle">2：{{ $t('tba.setWord2') }}API</p>
				<p class="bottom2PStyle" @click="open_account"><strong style="color: #666">3：{{ $t('tba.setWord3') }}</strong></p>
			</div>

			<div class="bottom1">
				<van-row type="flex" justify="space-around">
					<van-col span="11"><van-button class="btnStyle mainBackColor2" style="margin: auto;display: block" @click="setKey()" type="primary">{{ $t('tba.setup') }}</van-button></van-col>
					<van-col span="11"><van-button class="btnStyle mainBackColor2" style="margin: auto;display: block" @click="getKey()" type="primary">{{ $t('redRecode.examine') }}</van-button></van-col>
				</van-row>
			</div>
		</div>
	</div>
</template>

<script>
import commonHead from '@/components/commonHead';

export default {
	name: 'viewAPI2',
	components: {
		// TitleTwo,
		commonHead
	},
	data() {
		return {
			value: '00000',
			phone: '', //  用户手机号
			// popupShow: false,
			// popupShow2: false,
			// popupShow3: false,
			showKeyboard: false,
			exchange_name: '',
			email: '',
			codeSending: false,
			inputCode: '',
			exchange_id: 0,
			article_id: 0,
			list2: {},
			flag: false,
			ifhave: false,
			url: '',
			theTime: 60,
			vcode_method: 'phone',
			show: false,
			apiUpdate: {
				key: '',
				secret: '',
				passphrase: ''
			}
		};
	},
	created() {
		this.exchange_name = this.$route.query.exchange_name;
		this.exchange_id = this.$route.query.exchange_id;
		// this.getKey();
		this.initData();
		// this.getKey();
	},

	methods: {
		getId() {
			this.$post2('Article/Api/Index/getExchangeHelpID', { exchange_id: this.exchange_id }).then(res => {
				this.$router.push(`viewArticle?id=${res.id}`);
			});
		},

		initData() {
			this.$post2('user/api/index/getMetaInfo', {})
				.then(res => {
					this.email = res.email;
					this.phone = res.phone;
					this.vcode_method = res.vcode_method;

					if (this.exchange_id == 1) {
						this.url = res.huobi_link;
					} else if (this.exchange_id == 2) {
						this.url = res.bian_link;
					} else if (this.exchange_id == 3) {
						this.url = res.okex_link;
					}
					if (this.vcode_method == 'phone') {
					}
				})
				.catch(e => {
					this.$toast.fail(e);
				});
		},
		open_account() {
			console.log(this.url);
			this.$newBrowser(this.url);
		},
		// 获取验证码
		onSendCode() {
			if (this.codeSending) {
				return;
			}
			let url = 'security/user/authsmscode';
			if (this.vcode_method == 'email') {
				url = 'security/user/authemailcode';
			}
			this.theTime = 60;
			this.codeSending = true;
			this.doCountDown();
			this.$post2(url, {
				op: 'opsecret'
			}).then(res => {
				console.log(res);
				this.sid = res.sid;
			});
		},
		// 又改成 一次定时器了 写的真烂...
		doCountDown() {
			if (this.theTime > 1) {
				this.theTime--;
				this.codeTimer = setTimeout(() => {
					this.doCountDown();
				}, 1000);
			} else {
				this.codeSending = false;
			}
		},
		
		// 设置交易所Key
		getKey() {
			this.$post2('Trade/Api/Index/getApiKey', {
				exchange_id: this.exchange_id,
				sid: this.sid,
				code: this.inputCode
			})
				.then(res => {
					this.apiUpdate.key = res.api_key;
					this.apiUpdate.secret = res.api_secret;
					this.article_id = res.article_id;
				})
				.catch(e => {
					this.$toast.fail(e);
				});
		},
		setKey() {
			this.$post2('Trade/Api/Index/setApiKey', {
				exchange_id: this.exchange_id,
				key: this.apiUpdate.key,
				secret: this.apiUpdate.secret,
				passphrase: this.apiUpdate.passphrase,
				sid: this.sid,
				code: this.inputCode
			})
				.then(res => {
					this.$toast('设置成功');
					this.onClickLeft();
				})
				.catch(e => {
					this.$toast.fail(e);
				});
		},
		onClickRight() {
			this.$router.push({
				path: 'viewArticle',
				query: {
					id: this.article_id
				}
			});
		},
		onClickLeft() {
			this.$router.push('/apiAuthorization2');
		},
		onCancel() {
			Toast('取消');
		},
		btnChange() {
			this.show = true;
		}
	}
};
</script>

<style lang="less" scoped>
.viewAPI2 {
	// background: #ffffff;

	.bodyStyleDivStyleP {
		margin: 0.56rem 0 0.2rem 0;
	}

	.body1StyleInputStyle {
		border: 0;
		font-size: 0.28rem;
		width: 80%;
		line-height: 0.7rem;
	}
	.body1StyleInputStyle::-webkit-input-placeholder,
	.body1StyleInputStyle:-moz-placeholder,
	.body1StyleInputStyle::-moz-placeholder,
	.body1StyleInputStyle:-ms-input-placeholder,
	.body1StyleInputStyle::-ms-input-placeholder,
	.body1StyleInputStyle::placeholder {
		// color: #D6D6D6 !important;
		color: #FFFFFF !important;
	}

	.bottom2DivStyle {
		// border-top: 0.27rem solid RGBA(246, 248, 249, 1);
		// padding-top: 0.29rem;
		margin-bottom: 2.5rem;
	}

	/*.bodyStyleDivStyle {*/
	/*    border-bottom: 1px solid rgba(0, 0, 0, 0.1);*/
	/*    padding-bottom: 0.1rem;*/
	/*}*/

	.pc_in {
		position: relative;
		float: left;
		width: 6.7rem;
		height: 1.12rem;
		border: none;
	}

	.pc_in .divbox {
		display: flex;
		width: 100%;
		height: 1.12rem;
		overflow: hidden;
	}

	.pc_in .divbox span {
		flex: 1;
		height: 100%;
		border-bottom: #e6e8ed solid 1px;
		border-right: none;
		margin: 0 0.16rem;
	}

	.pc_in .divbox span.bl {
		border-color: #000;
	}

	.pc_in p {
		position: absolute;
		width: 100%;
		height: 1.12rem;
		line-height: 1.12rem;
		top: 0;
		left: 0;
		background: none;
		overflow: hidden;
	}

	.pc_in p input {
		float: left;
		width: 100%;
		height: 0.8rem;
		line-height: 0.8rem;
		margin-top: 0.2rem;
		letter-spacing: 0.84rem;
		background: none;
		text-indent: 0.4rem;
		font-size: 0.48rem;
	}

	.getCodeBtn {
		color: #90c4ff;
		width: 1.5rem;
		height: 0.5rem;
		font-size: 0.24rem;
		line-height: 0.5rem;
		background: none;
		border: 1px solid #90c4ff;
		border-radius: 4px;
		margin-top: 0.1rem;
		float: right;
	}

	.bottom2PStyle {
		font-size: 0.25rem;
		font-weight: 500;
		color: #999999;
		margin: 0 0.27rem 0.19rem;
	}

	.bottom3PStyle {
		color: #0f0f0f;
		margin: 0.3rem;
		font-size: 0.3rem;
	}

	.body1StyleSPan {
		color: #ff4b04;
	}

	.body1StylepFont {
		color: #666666;
		margin-top: 0.2rem;
		font-size: 0.28rem;
		margin-bottom: 0.5rem;
	}

	/* @import "../../assets/css/puliceStyle.css"; */

	.body1StyleInputStyle {
		border: 0;
		border-bottom: 0 dashed gray;
		width: 80%;
	}

	.bodyStyleDivStyleP {
		margin-top: 0.3rem;
		margin-bottom: 0.2rem;
	}

	.bodyStyleDivStyle {
		line-height: 0.4rem;
		border-bottom: 1px solid #f2f2f2;
		margin-bottom: 0.2rem;
		// padding-bottom: 0.1rem;
	}

	.body1Style {
		font-size: 0.28rem;
		padding: 0.3rem;
	}

	.bottom1 {
		margin-top: 0.3rem;
		padding-bottom: 0.3rem;
	}
	.help-btn {
		color: #29aae1;
		position: absolute;
		right: 10px;
		top: 10px;
		z-index: 999;
	}
}
</style>
